export const VUE_MOUNTED_ATTRIBUTE = "data-vue-mounted";

export function getMountElements(root, selector) {
  const elements = [];

  if (root instanceof Element && root.matches(selector)) {
    elements.push(root);
  }

  if (root instanceof Document || root instanceof Element) {
    elements.push(...root.querySelectorAll(selector));
  }

  return Array.from(new Set(elements));
}

export function readPayload(element) {
  const payloadElementId = element.dataset.payloadElementId || "";
  const payloadElement = payloadElementId ? document.getElementById(payloadElementId) : null;

  if (!payloadElement) {
    return {};
  }

  try {
    const parsed = JSON.parse(payloadElement.textContent || "{}");
    return parsed && typeof parsed === "object" && !Array.isArray(parsed) ? parsed : {};
  } catch (_error) {
    return {};
  }
}
